export default __webpack_public_path__ + "static/media/img-drag-drop-blue.885cc0ea.svg";